
import {Inject, Injectable, InjectionToken} from '@angular/core';
import {HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, timeout} from 'rxjs';
import {environment} from "../../../../environments/environment";

export const DEFAULT_TIMEOUT = new InjectionToken<number>('defaultTimeout');
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(@Inject(DEFAULT_TIMEOUT) protected defaultTimeout: number) {
    }
    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        // Clone the request and set headers if needed
        const authReq = req.clone({
            headers: req.headers
                .set('X-Api-Key', environment.apiKey)
        });
        const timeoutValue = req.headers.get('timeout') || this.defaultTimeout;
        const timeoutValueNumeric = Number(timeoutValue);
        // Pass the cloned request with headers to the next handler
        return next.handle(authReq).pipe(timeout(timeoutValueNumeric));
    }
}
